import { LambdaSchema } from "./types";

const schema: LambdaSchema = {
  columns: [
    { key: "summarize_job_name", label: "summarize_job_name" },
    { key: "llm_calls", label: "llm_calls" },
    { key: "total_codes", label: "total_codes" },
    { key: "codes", label: "codes", transform: "joinComma" }
  ],
};

export default schema;

